// extracted by mini-css-extract-plugin
export default {"switcher":"LanguageSwitcher_switcher__fkWWS","switcher__button--active":"LanguageSwitcher_switcher__button--active__BIvW5"};